<template>
  <div id="gpayScript" class="example" style="min-height: 2rem;">
    <div ref="googlePay" style="height: 44px"></div> <!--button wrapper-->

  </div>
</template>
<script>
// import { markRaw, toRaw } from 'vue';

/* eslint-disable */

export default {
  name: "GooglePay",
  props: {
    isTest: {
      type: Boolean
    },
    merchantId: {
      type: String,
      required: true
    },
    merchantName: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    totalPriceStatus: {
      type: String,
      default: "FINAL"
    },
    totalPrice: {
      type: String,
      default: "1.00",
      // required: true,
    },
    allowedCardNetworks: {
      type: Array,
      default: () => { return  [
        "MASTERCARD",
        "VISA",
      ]}
    },
    tokenizationSpecification: {
      type: Object,
      default: () => { return  {
        type: "PAYMENT_GATEWAY",
        parameters: {
          gateway: 'decta', // HEXOPAY
          gatewayMerchantId: '4197709c-37f2-48a1-a433-69c776787f30',
        },
      }}
    },
    baseRequest: {
      type: Object,
      default: () => { return  {
        apiVersion: 2,
        apiVersionMinor: 0,
      }}
    },
  },
  data: () => ({
    config: {
     
      // baseRequest: {
      //   apiVersion: 2,
      //   apiVersionMinor: 0,
      // },
    
      // tokenizationSpecification: {
      //   type: "PAYMENT_GATEWAY",
      //   parameters: {
      //     gateway: 'decta', // HEXOPAY
      //     gatewayMerchantId: '4197709c-37f2-48a1-a433-69c776787f30',
      //   },
      // },
     
      // allowedCardNetworks: [
      //   "MASTERCARD",
      //   "VISA",
      // ],
    
      allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
    },
    gpLoaded: false
  }),

  mounted() {

    this.injectGooglePayScripts()

    // // This loads the google pay button on the screen.
    // // I used a timeout because I need to wait for the
    // // script to load, since I'm loading it when the page mounts
    // setTimeout(() => this.loadGooglePay(), 2000);
    // setTimeout(() => this.injectGooglePayScripts(), 2000);

  },
  computed: {},
  methods: {
    injectGooglePayScripts() {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://pay.google.com/gp/p/js/pay.js')
      script.setAttribute('async', 'async')
      document.getElementById('gpayScript').appendChild(script)
      script.onload = () => { 
        this.gpLoaded = true 
        this.loadGooglePay()
      }
    },
    loadGooglePay() {
      const baseCardPaymentMethod = {
        type: "CARD",
        parameters: {
          allowedAuthMethods: [...this.config.allowedCardAuthMethods],
          allowedCardNetworks: [...this.allowedCardNetworks],
        },
      }
     
      const cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
        tokenizationSpecification: {...this.tokenizationSpecification},
      })

      console.log('DEBUG 111', cardPaymentMethod)

      let paymentsClient = null;
     
      const getGoogleIsReadyToPayRequest = () => {
        return Object.assign({}, {...this.baseRequest}, {
          allowedPaymentMethods: [baseCardPaymentMethod],
        });
      }

      const getGooglePaymentDataRequest = () => {
        const paymentDataRequest = Object.assign({}, {...this.baseRequest});
        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
        paymentDataRequest.transactionInfo = {...getGoogleTransactionInfo()};
        paymentDataRequest.merchantInfo = {
          merchantId: this.merchantId, // PROP
          merchantName: this.merchantName, // PROP
        };
        // TEMP
        // paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];
        return paymentDataRequest;
      };

      const onPaymentAuthorized = (data) => {
        console.log('DEBUG onPaymentAuthorized', data)
      }

  
      const getGooglePaymentsClient = () => {
        if (paymentsClient === null) {
          paymentsClient = new google.payments.api.PaymentsClient({
            environment: this.isTest ? 'TEST': 'PRODUCTION', // PROP
            // TEMP?
            // paymentDataCallbacks: {
            //   onPaymentAuthorized: onPaymentAuthorized
            // }
          });
        }
        return paymentsClient;
      }

      const onGooglePayLoaded = () => {
        const paymentsClient = getGooglePaymentsClient();
        paymentsClient
          .isReadyToPay(getGoogleIsReadyToPayRequest())
          .then((response) => {
            if (response.result) {
              addGooglePayButton();
              // @todo prefetch payment data to improve performance after confirming site functionality
              // prefetchGooglePaymentData();
              this.$emit('loaded', response.result);
            }
          })
          .catch((err) => {
            // show error in developer console for debugging
            console.error(err);
            this.$emit('loadedError', err);
          });
      }

      const addGooglePayButton = () => {
        const paymentsClient = getGooglePaymentsClient();
        const button = paymentsClient.createButton({
          buttonType: 'pay', // TODO?
          buttonColor: 'white',
          buttonSizeMode: 'fill',
          onClick: onGooglePaymentButtonClicked,
        });
        this.$refs.googlePay.appendChild(button);
      }

      /**
       * Provide Google Pay API with a payment amount, currency, and amount status
       *
       * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#TransactionInfo|TransactionInfo}
       * @returns {object} transaction info, suitable for use as transactionInfo property of PaymentDataRequest
       */
      const getGoogleTransactionInfo = () => ({
        // countryCode: "GB",
        currencyCode: this.currency, // PROP
        totalPriceStatus: this.totalPriceStatus, // PROP 
        // set to cart total
        totalPrice: this.totalPrice, // PROP
      });


      // function prefetchGooglePaymentData() {
      //   const paymentDataRequest = getGooglePaymentDataRequest();
      //   // transactionInfo must be set but does not affect cache
      //   paymentDataRequest.transactionInfo = {
      //     totalPriceStatus: "NOT_CURRENTLY_KNOWN",
      //     currencyCode: "USD",
      //   };
      //   const paymentsClient = getGooglePaymentsClient();
      //   paymentsClient.prefetchPaymentData(paymentDataRequest);
      // }

     
      const onGooglePaymentButtonClicked = () => {
        const paymentDataRequest = getGooglePaymentDataRequest();
        paymentDataRequest.transactionInfo = {...getGoogleTransactionInfo()};

        console.log('DEBUG payment data request', paymentDataRequest)
        const paymentsClient = getGooglePaymentsClient();
        paymentsClient
          .loadPaymentData(paymentDataRequest)
          .then((paymentData) => {
            // handle the response
            console.log('DEBUG  loadPaymentData', paymentData)
            processPayment(paymentData);
          })
          .catch((err) => {
            // show error in developer console for debugging
            console.log('DEBUG HEXOPAY GPAY error', err);
            console.log('DEBUG HEXOPAY GPAY error.response', err?.statusCode);
            // console.error(err);
            this.$emit('paymentError', err);
          });
      }
      /**
       * Process payment data returned by the Google Pay API
       *
       * @param {object} paymentData response from Google Pay API after user approves payment
       * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentData|PaymentData object reference}
       */
      const processPayment = (paymentData) => {
        // show returned data in developer console for debugging
        // @todo pass payment token to your gateway to process payment
        // const paymentToken =
        //   paymentData.paymentMethodData.tokenizationData.token;
        // const paymentMethodData =
        //   paymentData.paymentMethodData;
        this.$emit('paymentSuccess', paymentData);
      }

      onGooglePayLoaded();
    },
  },
};
</script>